import { MoreVertical } from "lucide-react";
import { Button } from "./ui/button";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from "./ui/dropdown-menu";

export function RowActionMenu({
  isRTL,
  onView,
  onEdit,
  onConvert,
  onDelete,
  onApprove,
  onDisburse,
  onReconcile,
}: {
  isRTL: boolean;
  onView?: () => void;
  onEdit?: () => void;
  onConvert?: () => void;
  onDelete?: () => void;
  onApprove?: () => void;
  onDisburse?: () => void;
  onReconcile?: () => void;
}) {
  const hasMain = !!onView || !!onEdit;
  const hasExtra =
    !!onConvert ||
    !!onDelete ||
    !!onApprove ||
    !!onDisburse ||
    !!onReconcile;

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button
          variant="ghost"
          size="icon"
          className="h-9 w-9 rounded-full hover:bg-white/5"
          onClick={(e) => e.stopPropagation()}
          aria-label="Actions"
          title="Actions"
        >
          <MoreVertical className="h-5 w-5" />
        </Button>
      </DropdownMenuTrigger>

      <DropdownMenuContent
        align={isRTL ? "start" : "end"}
        sideOffset={8}
        className="w-48"
        onClick={(e) => e.stopPropagation()}
      >
        {/* OPTIONAL View */}
        {onView && (
          <DropdownMenuItem onClick={onView}>
            View
          </DropdownMenuItem>
        )}

        {/* OPTIONAL Edit */}
        {onEdit && (
          <DropdownMenuItem onClick={onEdit}>
            Edit
          </DropdownMenuItem>
        )}

        {/* Separator only if both groups exist */}
        {hasMain && hasExtra && <DropdownMenuSeparator />}

        {/* OPTIONAL Convert */}
        {onConvert && (
          <DropdownMenuItem onClick={onConvert}>
            Convert to Customer
          </DropdownMenuItem>
        )}

        {/* OPTIONAL Reconcile */}
        {onReconcile && (
          <DropdownMenuItem onClick={onReconcile}>
            Reconcile
          </DropdownMenuItem>
        )}

        {/* OPTIONAL Approve */}
        {onApprove && (
          <DropdownMenuItem onClick={onApprove}>
            Approve
          </DropdownMenuItem>
        )}

        {/* OPTIONAL Disburse */}
        {onDisburse && (
          <DropdownMenuItem onClick={onDisburse}>
            Disburse
          </DropdownMenuItem>
        )}

        {/* OPTIONAL Delete */}
        {onDelete && (
          <DropdownMenuItem
            onClick={onDelete}
            className="text-destructive focus:text-destructive"
          >
            Delete
          </DropdownMenuItem>
        )}
      </DropdownMenuContent>
    </DropdownMenu>
  );
}